import { FormControl, TextField } from '@mui/material';
import { IRON } from 'styles/Colors';
import { isFunction } from 'lodash';
import React, { useEffect, useState } from 'react';

export default function SocialSecurityNumber(props) {
  const {
    id,
    name,
    label,
    value,
    error,
    formControlStyle = {},
    presetDisabled,
    maskType,
    onTouch,
    onBlur,
    isVisible,
    onChange,
    dynamicLabel,
    additionalProp,
    requiredStyle,
    ...rest
  } = props;
  const [focus, setFocus] = useState(false);
  const [touched, setTouched] = useState(false);
  const [hasFiredJukebox, setHasFiredJukebox] = useState(false);

  const [displayValue, setDisplayValue] = useState('');
  useEffect(() => {
    if (value && value.length === 9) {
      switch (maskType) {
        case 'full':
          setDisplayValue(`●●● ●● ●●●●`);
          break;
        case 'partial':
          setDisplayValue(`●●● ●● ${value.slice(-4)}`);
          break;
        default:
          setDisplayValue(value);
      }
    }
  }, []);

  const handleChange = (val) => {
    setHasFiredJukebox(false);
    if (isFunction(onChange)) {
      onChange(val);
    }
    if ((touched || error) && isFunction(onTouch)) {
      onTouch(val);
    }
  };

  const handleBlur = async () => {
    setFocus(false);
    setTouched(true);
    if (!hasFiredJukebox) {
      setHasFiredJukebox(true);
      if (isFunction(onBlur)) {
        onBlur(value);
      }
    }
  };

  if (presetDisabled && !error) {
    return (
      <>
        {isVisible && (
          <FormControl css={formControlStyle}>
            <TextField
              css={{
                background: 'linear-gradient(180deg, #FFFFFF 0%, #F2F2F2 100%)'
              }}
              id={id}
              label={label}
              type='text'
              variant='outlined'
              value={displayValue}
              error={!!error}
              helperText={error}
              InputLabelProps={{
                shrink: !!displayValue,
                style: { color: IRON }
              }}
              inputProps={{
                'data-testid': 'ssn-input-disabled',
                inputMode: 'numeric'
              }}
              disabled={presetDisabled}
            />
          </FormControl>
        )}
      </>
    );
  }
  return (
    <>
      {isVisible && (
        <FormControl css={formControlStyle}>
          <TextField
            css={[!value ? requiredStyle : null]}
            id={id}
            label={label}
            type={focus ? 'text' : 'password'}
            variant='outlined'
            value={value}
            onFocus={() => setFocus(true)}
            onBlur={(e) => handleBlur(e.target.value)}
            error={!!error}
            helperText={error}
            FormHelperTextProps={{ style: { margin: '0', fontSize: '12px' } }}
            InputLabelProps={{
              shrink: !!value || focus,
              style: { color: IRON }
            }}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            inputProps={{
              'data-testid': 'ssn-input',
              inputMode: 'numeric'
            }}
            onChange={(e) => {
              handleChange(e.target.value);
            }}
            {...rest}
          />
        </FormControl>
      )}
    </>
  );
}
